import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";

import ProductBannerCard from "../../../components/common/ProductBannerCard";

const ProductBanner = () => {
  const productBanners = [
    // Dữ liệu sản phẩm mẫu
    {
      id: 1,
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227238/iPhone-Air_xlkdya.png",
      name: "iPhone Air",
      descr:
        "Thiết kế siêu mỏng nhẹ, màn hình OLED sắc nét, hiệu năng mượt mà; camera thông minh ghi lại khoảnh khắc rõ nét suốt ngày dài.",
      backgroudColor: "white",
      link: "/products/iPhone/iphone-air",
    },
    {
      id: 2,
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227239/ipad-air-6_ell6il.png",
      name: "iPad Air 6",
      descr:
        "Màn hình Liquid Retina sống động, hiệu năng mạnh mẽ, hỗ trợ Apple Pencil và bàn phím - hoàn hảo cho học tập, làm việc và sáng tạo.",
      backgroudColor: "#F9F9F9",
      link: "/products/iPad/ipad-air-6-m2-13-inch-5g-128gb",
    },
    {
      id: 3,
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227241/apple-watch-series-11_avp8wy.png",
      name: "Apple Watch Series 11",
      descr:
        "Theo dõi sức khỏe toàn diện, phát hiện tập luyện thông minh, màn hình sáng rõ và pin dùng cả ngày.",
      backgroudColor: "#EAEAEA",
      link: "/products/watch/apple-watch-series-11",
    },
    {
      id: 4,
      image:
        "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759227240/airpods-pro-2_frwabf.png",
      name: "AirPods Pro 2",
      descr:
        "Khử ồn chủ động, Xuyên âm thông minh, âm thanh không gian sống động; kết nối mượt với thiết bị Apple kèm hộp sạc USB-C tiện lợi",
      backgroudColor: "#2C2C2C",
      isDark: true,
      link: "/products/airpods/airpods-pro-gen-2-usb-c",
    },

    // ... thêm dữ liệu
  ];

  return (
    <div className="bg-white w-full">
      <div className="lg:hidden">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000 }}
          modules={[Pagination, Autoplay]}
        >
          {productBanners.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductBannerCard {...product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="hidden lg:grid lg:grid-cols-4">
        {productBanners.slice(0, 4).map((product) => (
          <ProductBannerCard key={product.id} {...product} />
        ))}
      </div>
    </div>
  );
};

export default ProductBanner;
